export const minPassengerCount = 1

export const maxPassengerCount = 8
